module.exports = __webpack_public_path__ + "img/BGLogoIntro.47e1af72.jpg";